module.exports = __webpack_public_path__ + "static/img/coin_blue.37944a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_blue.png
// module id = 35
// module chunks = 1